module.exports = __webpack_public_path__ + "img/select-dark-01.c0c6cda4.png";